export const AUTH_FORM_HEADER_MARK_ALT = 'Scalar';
export const AUTH_FORM_HEADER_FIRM_LOGO_ALT = 'Organization logo';
